import styled from '@emotion/styled'

import { Button1 } from './Button1'

export const Button3 = styled(Button1)({
  fontSize: '0.875rem', // 14px
  fontWeight: 500,
  letterSpacing: '0.01em',
})
